// iOS zooms in on inputs with font-size < 16px. Temporarily setting maximum-scale=1
// forces the browser to reset the zoom level when the input loses focus.
let inFlight = false;

const stripMaximumScale = (content: string) =>
  content
    .split(',')
    .map((s) => s.trim())
    .filter((s) => !/^maximum-scale\s*=/i.test(s))
    .join(', ');

export const resetMobileZoom = () => {
  if (inFlight) return;

  const viewport = document.querySelector<HTMLMetaElement>(
    'meta[name="viewport"]',
  );
  if (!viewport) return;

  inFlight = true;
  const original = stripMaximumScale(viewport.content);
  viewport.content = `${original}, maximum-scale=1`;
  requestAnimationFrame(() => {
    viewport.content = original;
    inFlight = false;
  });
};
